module.exports = __webpack_public_path__ + "static/media/walking-worker.5f3932aa.png";